export default __webpack_public_path__ + "static/01-03-reading-glossary-tool-535e28af434c6ef3a52491e107ffb861.mp4";